import * as yup from 'yup';

export interface ExerciseFormValues {
  screenshot_url?: File | string;
  title: string;
  description: string;
  url: string;
  video_type: 'B' | 'Y';
  file: string | File;
  tags: number[];
  partitions: number[];
  module?: number;
}
export type ExerciseFormValuesWithId = ExerciseFormValues & { id: number };
export const exerciseCreateSchema = yup
  .object()
  .shape({
    title: yup
      .string()
      .required('Укажите название видеоролика')
      .min(1, 'Слишком короткое название'),
    screenshot_url: yup.string().required('Загрузите обложку'),
    file: yup.mixed().nullable(),
    url: yup.string(),
    video_type: yup.string(),
    tags: yup.array(),
    // module: yup
    //   .number()
    //   .test('zero_is_valid', 'Выберите раздел', (value) => value !== 0 || value == null),
  })
  .test({
    name: 'video is required',
    test: (value, ctx) => {
      switch (value.video_type) {
        case 'Y':
          if (!value.url || !value.url.length) {
            return ctx.createError({
              message: 'Не добавлена ссылка',
              path: 'url',
            });
          }
          break;

        case 'B':
          if (!value.file) {
            return ctx.createError({
              message: 'Не добавлен видеофайл',
              path: 'file',
            });
          }
          break;
        default:
          break;
      }
      return true;
    },
  });

export const exerciseUpdateSchema = yup
  .object()
  .shape({
    title: yup
      .string()
      .required('Укажите название видеоролика')
      .min(1, 'Слишком короткое название'),
    screenshot_url: yup.string().required('Загрузите обложку'),
    file: yup.mixed().nullable(),
    url: yup.string(),
    video_type: yup.string(),
    tags: yup.array(),
    // module: yup
    //   .number()
    //   .test('zero_is_valid', 'Выберите раздел', (value) => value !== 0 || value == null),
  })
  .test({
    name: 'video is required',
    test: (value, ctx) => {
      if (!value?.url?.length && !value.file) {
        return ctx.createError({
          message: 'Не добавлен видеофайл',
          path: 'url',
        });
      }
      return true;
    },
  });
